import React from 'react';

import Link from 'ati-ui-react/components/Link';
import Phone from 'ati-ui-react/components/icons/Phone';
import theme from 'theme';
import cn from 'classnames';
import { CallButtonStyles } from './CallButtonStyles';

function CallButton({ contacts }) {
  const contact = !!contacts && contacts?.[0];
  const phone = (!!contact && contact?.telephone) || contact?.mobile;

  if (!phone) return null;

  return (
    <CallButtonStyles onClick={(e) => e.stopPropagation()}>
      <Link href={`tel:${phone}`} rel="noopener noreferrer">
        <Phone width={24} height={24} color={theme.colors.color_white} />
      </Link>
    </CallButtonStyles>
  );
}

export default CallButton;
